import React from "react";

/**
 * Big bold Fraunces wordmark — funky display serif a la "Avvera".
 * Mixed case: "Localize" (title case serif) + "HER" (uppercase serif).
 */
export function Logo({ light = false, size = "md", className = "" }) {
  const sizes = {
    sm: "text-[1.5rem]",
    md: "text-[1.85rem]",
    lg: "text-[3rem]",
    xl: "text-[5rem] sm:text-[7rem] lg:text-[9rem]",
  };
  const color = light ? "var(--lh-cream)" : "var(--lh-espresso)";
  return (
    <span
      className={`lh-wordmark ${sizes[size] || sizes.md} ${className}`}
      style={{ color }}
      data-testid="brand-logo"
    >
      <span className="localize">Localize</span>
      <span className="her">HER</span>
    </span>
  );
}
